module.exports = import("/tune-app/remoteEntry.js");;